import { generatePath, Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Flex, Table, Tag, Typography } from "antd"
import { ColumnsType, TableProps } from "antd/es/table"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { paths } from "@src/app/paths"
import { InvoiceCollection } from "@src/pages/paymentLinks/classes/InvoiceCollection"
import {
  InvoiceResponse,
  InvoiceResponseStatusEnum,
} from "@src/shared/api/generated"
import { WithCollection } from "@src/shared/classes/Collection/types"
import { TableFilters } from "@src/shared/componemts/TableFilter"
import { dateTimeFormat } from "@src/shared/date"

type PaymentsLinksTableProps = WithCollection<InvoiceCollection> & {
  paymentPageUrl?: string
}
export const PaymentsLinksTable = observer(
  ({ collection, paymentPageUrl }: PaymentsLinksTableProps) => {
    const columns: ColumnsType<InvoiceResponse> = [
      {
        dataIndex: "id",
        render: (_, { id }) => <IdItem id={id!} />,
        title: "ID",
      },
      {
        dataIndex: "name",
        render: (_, { customer_name, id = "" }) => {
          return (
            <Link
              id="GENERATED_ID_PAYMENTSLINKSTABLE_LINK_VOID_1"
              to={generatePath(paths.paymentLinkShow, { id })}
            >
              {customer_name}
            </Link>
          )
        },
        title: "Customer",
      },
      {
        dataIndex: "memo",
        title: "Memo",
      },
      {
        dataIndex: "fiat_price",
        render: (_, { fiat_price }) => {
          if (!fiat_price) return null

          return (
            <Typography.Text>{`${fiat_price.amount} (${fiat_price.symbol})`}</Typography.Text>
          )
        },
        title: "Amount",
      },
      {
        dataIndex: "status",
        render: (_, { status }) => {
          const cMap = {
            [InvoiceResponseStatusEnum.Open]: "geekblue",
            [InvoiceResponseStatusEnum.Paid]: "green",
            [InvoiceResponseStatusEnum.Unresolved]: "geekblue",
            [InvoiceResponseStatusEnum.Viewed]: "geekblue",
            [InvoiceResponseStatusEnum.Void]: "error",
          }

          return (
            <Tag color={cMap[status!] ?? "geekblue"}>
              {status === "void" ? "voided" : status}
            </Tag>
          )
        },
        title: "Status",
      },
      {
        dataIndex: "created_at",
        render: (_, { created_at }) => dateTimeFormat(created_at!),
        title: "Created Date",
      },
      {
        dataIndex: "id",
        render: (_, { id }) => (
          <IdItem id={`${paymentPageUrl}/invoice/${id}`} />
        ),
        title: "Share a link",
      },
    ]

    return (
      <Flex gap={32} vertical>
        <TableFilters
          fields={collection.fConf}
          onChange={collection.filter.onFormChange}
          state={collection.filter.state}
        />
        <Table
          columns={columns}
          dataSource={collection.items}
          loading={collection.isLoading}
          pagination={collection.pagination}
          scroll={{ x: true }}
        />
      </Flex>
    )
  },
)
